import { Dashboard, generateDefaultDashboardItems } from "@base/web";

const DashboardConfig: Dashboard.DashboardConfig = {
  items: generateDefaultDashboardItems(),
}

export default DashboardConfig;